import { createFileRoute } from "@tanstack/react-router";

import {
  DEFAULT_CHARGES_LIST_SORTING,
  getInfiniteChargesQueryOptions,
} from "../../../entities/charge/list-query-options";
import { parseFilterSearchToRequestDto } from "../../../entities/charge/lib";
import { chargesSearchParamsSchema } from "../../../pages/charges-page/types";

export const Route = createFileRoute("/_layout-main/charges/")({
  validateSearch: chargesSearchParamsSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context: { queryClient }, deps: search }) =>
    queryClient.prefetchInfiniteQuery(
      getInfiniteChargesQueryOptions({
        filter: parseFilterSearchToRequestDto(search),
        sorting: {
          columnName: search.sorting ?? DEFAULT_CHARGES_LIST_SORTING.columnName,
          direction:
            search.sortingDir ?? DEFAULT_CHARGES_LIST_SORTING.direction,
        },
      }),
    ),
});
